import React from 'react';
import styles from './Footer.module.css';
import logoWhite from '../../assets/img/logo_white.png';

import {Box, Container, Typography, Hidden} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';


const Footer = () => {
    return (
        <footer className={styles.footer}>
            <Container maxWidth="sm">
                <Grid container justifyContent={'center'} alignItems={'center'} width="100%" spacing={2}>
                    <Hidden smDown>
                        <Grid sm={3}>
                            <Box 
                                display={'flex'} 
                                justifyContent={'center'} 
                                alignItems={'center'}
                                height="100%"
                            > 
                                <img src={logoWhite} alt="logo" className={styles['footer-logo']}/>
                            </Box>
                        </Grid>
                    </Hidden>
                    <Grid 
                        sm={9} 
                        flex={1} 
                        textAlign={"center"}
                    >
                        <Box textAlign={"left"}>
                            <Typography  variant="reference" component="p" color="white" fontWeight="300">
                                본사: 
                                <Typography variant="reference" component="span" color="white" fontWeight="300" paddingLeft="0.4rem">
                                    충남 천안시 서북구 두정상가1길 5, 새아스빌 202호
                                </Typography>
                            </Typography>

                            <Typography  variant="reference" component="p" color="white" fontWeight="300">
                                서울 사무소:
                                <Typography variant="reference" component="span" color="white" fontWeight="300" paddingLeft="0.4rem">
                                    서울특별시 서초구 서초대로64길 31
                                </Typography>
                            </Typography>

                            <Grid container>
                                <Grid xs={12} sm={4}>
                                    <Typography  variant="reference" component="p" color="white" fontWeight="300">Tel: 041-555-7422</Typography>
                                </Grid>
                                <Grid xs={12} sm={4}>
                                    <Typography variant="reference" component="p" color="white" fontWeight="300">Fax: 041-968-8422</Typography>
                                </Grid>
                            </Grid>
                            <Typography variant="reference" component="p" color="white" fontWeight="300" >dreamsafety1201@naver.com</Typography>
                            <Typography variant="reference" sx={{fontWeight: 'bold', color: 'gray'}}>Copyright © 드림산업안전센터. All rights reserved.</Typography>
                        </Box>
                    </Grid>
                </Grid>                    
            </Container>
        </footer>
    )
}

export default Footer;